if ($('#recipes').length) {
    $('#recipes__list').on('beforeChange', function(event, slick, direction){
        $('html, body').animate({
            scrollTop: $("#recipes").offset().top
        }, 1000);
    });

    $('#recipes__list').slick({
        infinite: false,
        slidesToShow: 1,
        arrows: false,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: '30px'
    });
    
    let heightAdjusted = false;
    doWhenInViewport($('#recipes__list').prev()[0], function(entries, observer) {
        if (entries[0].isIntersecting && !heightAdjusted) {
            $('#recipes__list .slick-list').css('height', $('.recipes__item.slick-current').outerHeight());
            heightAdjusted = true;
        }
    });    
}